export default __webpack_public_path__ + "5c5d09f25d54f7d2050593506523faea.svg";